// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__eY4A1","TextColor":"NavigationItems_TextColor__2D59T"};